import type { ContentEntry } from '../types/curriculum'

export const bonuses: ContentEntry[] = [
  {
    title: '🎁 Bono 1 — Fichas de evaluación postural imprimibles',
    groups: [
      {
        items: [
          'Evaluación inicial.',
          'Reevaluación a 30, 60 y 90 días.',
          'Registro de evolución.',
        ],
      },
    ],
  },
  {
    title: '🎁 Bono 2 — Biblioteca de ejercicios correctivos',
    groups: [
      {
        items: [
          'Ejercicios organizados por región corporal.',
          'Objetivos.',
          'Progresiones.',
          'Errores frecuentes.',
        ],
      },
    ],
  },
  {
    title: '🎁 Bono 3 — Programas listos para aplicar',
    groups: [
      {
        items: [
          'Programas para oficinistas.',
          'Adultos mayores.',
          'Embarazadas.',
          'Deportistas.',
        ],
      },
    ],
  },
  {
    title: '🎁 Bono 4 — Pack de clases grupales listas',
    groups: [
      {
        items: [
          'Clases completas listas para implementar.',
          'Objetivos.',
          'Variantes.',
          'Progresiones.',
        ],
      },
    ],
  },
  {
    title: '🎁 Bono 5 — Cuestionario de detección rápida',
    groups: [
      {
        items: [
          'Dolor cervical.',
          'Dolor lumbar.',
          'Sedentarismo.',
          'Hábitos laborales.',
          'Factores de riesgo postural.',
        ],
      },
    ],
  },
  {
    title: '🎁 BONO 6 — 100 Ejercicios con Banda Elástica',
    groups: [
      {
        heading: 'Capítulo 1. Introducción',
        items: [
          '1.1. Beneficios del trabajo con bandas.',
          '1.2. Tipos de bandas elásticas.',
          '1.3. Intensidades.',
          '1.4. Normas de seguridad.',
        ],
      },
      {
        heading: 'Capítulo 2. Ejercicios',
        items: [
          '2.1. Columna cervical.',
          '2.2. Hombros.',
          '2.3. Columna dorsal.',
          '2.4. Columna lumbar.',
          '2.5. Caderas.',
          '2.6. Miembros inferiores.',
          '2.7. Estabilidad del core.',
          '2.8. Progresiones.',
        ],
      },
    ],
  },
  {
    title: '🎁 BONO 7 — 100 Ejercicios con Pelota',
    groups: [
      {
        heading: 'Capítulo 1. Introducción',
        items: [
          '1.1. Tipos de pelotas.',
          '1.2. Beneficios.',
          '1.3. Seguridad durante la práctica.',
        ],
      },
      {
        heading: 'Capítulo 2. Ejercicios',
        items: [
          '2.1. Movilidad.',
          '2.2. Estabilidad.',
          '2.3. Equilibrio.',
          '2.4. Fortalecimiento postural.',
          '2.5. Columna vertebral.',
          '2.6. Miembros inferiores.',
          '2.7. Coordinación.',
          '2.8. Progresiones.',
        ],
      },
    ],
  },
  {
    title: '🎁 BONO 8 — 100 Ejercicios con Palo',
    groups: [
      {
        heading: 'Capítulo 1. Introducción',
        items: [
          '1.1. Utilización del palo.',
          '1.2. Beneficios.',
          '1.3. Errores frecuentes.',
        ],
      },
      {
        heading: 'Capítulo 2. Ejercicios',
        items: [
          '2.1. Alineación postural.',
          '2.2. Movilidad de hombros.',
          '2.3. Apertura torácica.',
          '2.4. Movilidad de la columna.',
          '2.5. Estabilidad escapular.',
          '2.6. Control del tronco.',
          '2.7. Miembros inferiores.',
          '2.8. Integración en clases.',
        ],
      },
    ],
  },
  {
    title: '🎁 BONO 9 — 100 Ejercicios para Poblaciones Especiales',
    groups: [
      {
        heading: 'Capítulo 1. Adultos mayores',
        items: [
          '1.1. Movilidad articular.',
          '1.2. Equilibrio.',
          '1.3. Fuerza funcional.',
          '1.4. Coordinación.',
          '1.5. Prevención de caídas.',
          '1.6. Adaptaciones.',
        ],
      },
      {
        heading: 'Capítulo 2. Embarazadas',
        items: [
          '2.1. Movilidad segura.',
          '2.2. Estabilidad lumbo-pélvica.',
          '2.3. Respiración.',
          '2.4. Fortalecimiento postural.',
          '2.5. Relajación.',
          '2.6. Adaptaciones por trimestre.',
        ],
      },
    ],
  },
  {
    title: '🎁 BONO 10 — 50 Clases de Emergencia Listas para Aplicar',
    groups: [
      {
        heading: 'Capítulo 1. Introducción',
        items: [
          '1.1. Cómo utilizar este material.',
          '1.2. Adaptaciones según el grupo.',
          '1.3. Organización de la clase.',
        ],
      },
      {
        heading: 'Capítulo 2. Clases de 30 minutos',
        items: [
          '2.1. Nivel inicial.',
          '2.2. Nivel intermedio.',
          '2.3. Dolor lumbar.',
          '2.4. Dolor cervical.',
          '2.5. Movilidad general.',
          '2.6. Adultos mayores.',
        ],
      },
      {
        heading: 'Capítulo 3. Clases de 45 minutos',
        items: [
          '3.1. Reeducación postural.',
          '3.2. Columna vertebral.',
          '3.3. Caderas.',
          '3.4. Hombros.',
          '3.5. Fortalecimiento postural.',
        ],
      },
      {
        heading: 'Capítulo 4. Clases de 60 minutos',
        items: [
          '4.1. Clase integral de movilidad.',
          '4.2. Clase de reeducación postural.',
          '4.3. Clase grupal.',
          '4.4. Clase individual.',
          '4.5. Nivel principiante.',
          '4.6. Nivel avanzado.',
        ],
      },
      {
        heading: 'Capítulo 5. Adaptaciones rápidas',
        items: [
          '5.1. Clases sin materiales.',
          '5.2. Clases con banda elástica.',
          '5.3. Clases con pelota.',
          '5.4. Clases con palo.',
          '5.5. Grupos reducidos.',
          '5.6. Grupos numerosos.',
        ],
      },
    ],
  },
]
